import _ from 'lodash';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from '../../../../global/cnr/reducers/reducerHelpers/dispatchProps';
import { mediaHelpers } from '../../importing/mediaResults';
import { sportsHelpers } from './reducerHelpers/sportsHelpers';
import { convertHelpers } from '../../../../global/common/convert';

const rts = {
  handleGet_mediaResults: 'handleGet_mediaResults',
  handleGet_mediaSeason: 'handleGet_mediaSeason',
  handleSet_mediaSeason: 'handleSet_mediaSeason',
  handleSet_mediaSeasonAlignments: 'handleSet_mediaSeasonAlignments',
  handleSet_mediaSeasonFull: 'handleSet_mediaSeasonFull',
  handleSet_mediaSeasonRecords: 'handleSet_mediaSeasonRecords',
  handleCreate_mediaSeason_db: 'handleCreate_mediaSeason_db',
  ...grts,
}

/** 
 * @param {object} state 
 * @param {object} action 
 * @returns 
 */
export const createMediaSeasonReducer = (state, action) => {

  const {
    pathViews,
    teams_info,
    database_fns,
  } = state

  const { type, dispatch, } = action
  const { teams } = teams_info ?? {}

  const _teams = _.cloneDeep(teams)
  convertHelpers.createItemKeys(_teams)

  const {
    handleSet_mediaSeasonFull,
    handleSet_mediaSeasonAlignments,
    handleSet_mediaSeasonRecords,
    handleStopUpdate,
  } = createMediaSeasonHandlers(dispatch)

  switch (type) {

    case rts.handleGet_mediaSeason:

      const { year: _sportsYear, _sportsModeSport, _sportsAbr, alignmentOnly, recordsOnly } = action
      let _mediaYear = _sportsYear
      let _season = 'fall'

      switch (_sportsModeSport) {
        case 'soccer':
        case 'football':
          _season = 'fall'
          break;
        case 'basketball':
          _season = 'winter'
          break;
        case 'baseball':
        case 'softball':
          _season = 'spring'
          break;
        default:
      }

      // handleGet_seasonalData(_sportsYear)

      const dateGroupKeys = sportsHelpers.generateDatesByYear([_mediaYear], _season)

      if (recordsOnly) {
        mediaHelpers.getMedia_alignments(action.yearCount, action.links_score, _sportsYear, _sportsAbr, _teams, handleSet_mediaSeasonRecords)
      } else if (alignmentOnly) {
        mediaHelpers.getMedia_alignment(action.links_score, _sportsYear, _sportsAbr, _teams, handleSet_mediaSeasonAlignments)
      } else {
        // pathViews, dateGroupKeys, links_score, year, _sportsAbr, teams, callback
        mediaHelpers.getMedia_alignmentAndResults(pathViews, dateGroupKeys[_mediaYear], action.links_score, _sportsYear, _sportsAbr, _teams, handleSet_mediaSeasonFull)

      }
      return state

    case rts.handleSet_mediaSeasonFull:
      const { mediaSeasonFull } = action
      const msdc = createCreateSeason(mediaSeasonFull)
      return { ...state, mediaSeason: mediaSeasonFull, mediaSeasonalData_current: msdc, updating: false }

    case rts.handleSet_mediaSeason:
      if (action.forPlayoffs) {
        if (state.mediaSeason) {
          const _media_season = _.cloneDeep(state.mediaSeason)
          const _mediaSeason = mediaHelpers.ammendMedia_season(database_fns, action.matches, _media_season.teams, pathViews, action.year, action._sportsAbr, true)
          _media_season.matches_playoffs = _mediaSeason.matches_playoffs
          return { ...state, mediaSeason: _media_season, updating: false }
        }
        return state
      } else {
        const _mediaSeason = mediaHelpers.ammendMedia_season(database_fns, action.matches, _teams, pathViews, action.year, action._sportsAbr, false, false, null, null, state.mediaSeason)
        return { ...state, mediaSeason: _mediaSeason, updating: false }
      }

    case rts.handleSet_mediaSeasonAlignments:
      const { results } = action
      const { teams: teams_media, sectionCounts, alignments, _url, sportsYearStandings, teamRecords } = results
      const _mediaSeasonA = mediaHelpers.ammendMedia_season(database_fns, null, teams_media, pathViews, action.year, action._sportsAbr, false, true, alignments, sectionCounts)
      if (_mediaSeasonA.teams) {
        _mediaSeasonA._teamsByName = _.groupBy(_mediaSeasonA.teams, 'name')
      }
      _mediaSeasonA.parentDataKeys_season = state.parentDataKeys_season
      _mediaSeasonA._url = _url
      _mediaSeasonA.sportsYearStandings = sportsYearStandings
      _mediaSeasonA.teamRecords = teamRecords
      return { ...state, mediaSeason: _mediaSeasonA, updating: false }

    case rts.handleSet_mediaSeasonRecords:
      const _teamRecords = {}
      const { results: resutsByYear, year } = action
      _.forEach(resutsByYear, (rby) => {
        const { teamRecords, sportsYearStandings } = rby
        _.forEach(teamRecords, (teamRecord, teamKey) => {
          if (!_teamRecords[teamKey]) { _teamRecords[teamKey] = { name: teamRecord.name, records: {} } }
          _teamRecords[teamKey].records[sportsYearStandings] = teamRecord[sportsYearStandings]
        })
      })
      return { ...state, mediaSeason: { teamRecords: _teamRecords, sportsYear: year, recordsOnly: true, parentDataKeys_season: state.parentDataKeys_season }, updating: false }

    case rts.handleCreate_mediaSeason_db:
      mediaHelpers.createMediaSeason_db(state.mediaSeason, action.createOptions, action.parentDataKeys, action._seasonalId, pathViews, handleStopUpdate)
      return state

    case rts.handleGet_mediaResults:
      return state

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterUpdate }, { gsMatchedRefreshed: false })

    default:
      return state
  }
}

export const createMediaSeasonHandlers = (dispatch) => {
  return {
    handleCreate_mediaSeason_db: (createOptions, parentDataKeys, _seasonalId) => { dispatch({ type: rts.handleCreate_mediaSeason_db, dispatch, createOptions, parentDataKeys, _seasonalId }) },
    handleGet_mediaResults: (latestSeason, isTemp) => { dispatch({ type: rts.handleGet_mediaResults, dispatch, latestSeason, isTemp }) },
    handleGet_mediaSeason: (year, _sportsModeSport, links_score, _sportsAbr, alignmentOnly, matchesOnly, recordsOnly, yearCount) => { dispatch({ type: rts.handleGet_mediaSeason, dispatch, year, _sportsModeSport, links_score, _sportsAbr, alignmentOnly, matchesOnly, recordsOnly, yearCount }) },
    handleSet_mediaSeasonAlignments: (results, year, _sportsAbr) => { dispatch({ type: rts.handleSet_mediaSeasonAlignments, dispatch, results, year, _sportsAbr }) },
    handleSet_mediaSeasonFull: (mediaSeasonFull) => { dispatch({ type: rts.handleSet_mediaSeasonFull, dispatch, mediaSeasonFull }) },
    handleSet_mediaSeasonRecords: (results, year, _sportsAbr) => { dispatch({ type: rts.handleSet_mediaSeasonRecords, dispatch, results, year, _sportsAbr }) },
    ...responseHandlers(dispatch),
  }
}

export const createMediaSeasonInitialState = (init_state) => {
  return {
    ...init_state,
  }
}

const createCreateSeason = (mediaSeason) => {
  const {
    details,
    matchGroups,
    sectionDates,
    seasonTeams,
    sectionCounts,
  } = mediaSeason ?? {}

  const xxx = {
    details,
    matchGroups,
    sectionDates,
    sectionCounts,
    teams: seasonTeams,
  }
  return xxx
}
